var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7761 37.0613C65.7244 38.0095 65.7244 39.5469 64.7761 40.4952L45.3511 59.9202C44.4029 60.8684 42.8655 60.8684 41.9172 59.9202L33.8235 51.8264C32.8752 50.8782 32.8752 49.3408 33.8235 48.3925C34.7717 47.4443 36.3091 47.4443 37.2574 48.3925L43.6342 54.7693L61.3422 37.0613C62.2905 36.113 63.8279 36.113 64.7761 37.0613Z",
    fill: "#EF3340"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    stroke: "#EF3340",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.717e33f2f59c56ed5d5e2c3eb79fc0d0.svg";
export { ForwardRef as ReactComponent };